// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links[data-v-18118dc6],form#login[data-v-18118dc6]{margin-top:20px}.links[data-v-18118dc6]{margin-bottom:43px}.submit-error[data-v-18118dc6]{color:#9081e6;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
